import React, { Component } from 'react'
import styled from 'styled-components'
import { Logo } from '../../../common/components'
import UserDropdown from '../../../features/components/UserDropdown'
import { withTenant } from '../../../context/tenantConfig'
import { Link } from 'react-router-dom'
import SearchBar from './JobsSearch'

const Header = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: fixed;
  z-index: 999;
  top: 0;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`

const Nav = styled.div`
  display: flex;
  justify-content: center;
  width: 90%;
`

const Navbar = styled.div`
  width: 100%;
  background-color: #ffffff;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Container = styled.div`
  width: 96%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  position: relative;
`

const Ul = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

const Li = styled.li`
  display: flex;
  align-items: center;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    bottom: 6px;
    left: 20px;
    right: 20px;
    height: 2px;
    background: ${props => props.theme.primary};
    transform: scaleX(${props => (props.isActive ? '1' : '0')});
    transform-origin: center;
    transition: transform 0.3s ease;
  }

  &:active {
    transform: scale(0.98);
  }

  &:hover {
    &::before {
      transform: scaleX(1);
    }
  }

  a {
    text-decoration: none;
    color: ${props => (props.isActive ? props.theme.primary : '#828282')};
    font-weight: ${props => (props.isActive ? '700' : '600')};
    font-size: 16px;
    cursor: pointer;
    padding: 12px 20px;
    border-radius: 8px;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;

    &:hover {
      color: ${props => props.theme.primary};
      background: ${props => props.theme.primary}10;
    }
  }

  /* Optional: Add icon support */
  svg {
    margin-right: 6px;
    transition: transform 0.3s ease;
  }

  &:hover svg {
    transform: translateY(-2px);
  }
`

class CandidateHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeLink: this.getActiveLink()
    }
  }

  componentDidMount() {
    // Update active link on route change
    window.addEventListener('popstate', this.updateActiveLink)
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.updateActiveLink)
  }

  getActiveLink = () => {
    const path = window.location.pathname
    if (path.includes('/c/dashboard')) return 'dashboard'
    if (path.includes('/c/profile')) return 'profile'
    if (path.includes('/c/applied-jobs')) return 'applied-jobs'
    if (path.includes('/c/jobs')) return 'jobs'
    return
  }

  updateActiveLink = () => {
    this.setState({ activeLink: this.getActiveLink() })
  }

  render() {
    const {
      tenant: { config }
    } = this.props

    const navLinks = [
      { id: 'dashboard', label: 'Dashboard', href: '/c/dashboard' },
      { id: 'profile', label: 'Profile', href: '/c/profile' },
      {
        id: 'applied-jobs',
        label: 'Applied Jobs',
        href: '/c/applied-jobs'
      },
      {
        id: 'jobs',
        label: 'Jobs',
        href: '/c/jobs'
      }
    ]

    return (
      <Header>
        <Navbar>
          <Container>
            <Logo
              style={{ width: 'auto', maxWidth: '150px', height: '60px' }}
            />
            <Nav>
              <Ul>
                {navLinks.map(link => {
                  const isActive = this.getActiveLink()
                  return (
                    <Li
                      key={link.id}
                      theme={config.theme}
                      isActive={isActive === link.id}
                    >
                      <Link to={link.href}>{link.label}</Link>
                    </Li>
                  )
                })}
              </Ul>
              <SearchBar
                onSearch={data => {
                  console.log('Search Params:', data)
                }}
              />
            </Nav>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <UserDropdown />
            </div>
          </Container>
        </Navbar>
      </Header>
    )
  }
}

export default withTenant(CandidateHeader)
